import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
})
export class ActionButtonComponent implements OnInit {
  constructor() {}

  @Input() action: any;
  @Output() submitAction = new EventEmitter<string>();
  ngOnInit(): void {}

  triggerAction(actionId: string): void {
    this.submitAction.emit(actionId);
  }
}
